export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            投稿爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8">你有重磅大瓜？欢迎向我们投稿爆料</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-2">邮箱投稿</h3>
              <p className="text-xs text-foreground-500 break-all">tips@jindagua.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-wechat-line text-accent-500 text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-2">微信投稿</h3>
              <p className="text-xs text-foreground-500">添加微信号</p>
              <p className="text-xs text-foreground-500 break-all">jindagua2024</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                <i className="ri-chat-smile-2-line text-secondary-600 text-xl"></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-2">匿名爆料</h3>
              <p className="text-xs text-foreground-500">通过匿名表单提交</p>
              <p className="text-xs text-foreground-500">严格保护隐私</p>
            </div>
          </div>

          <p className="text-sm text-foreground-500">
            我们承诺严格保护投稿人隐私，所有爆料信息需经人工审核后发布。投稿即表示同意我们的信息使用条款。
          </p>
        </div>
      </div>
    </section>
  );
}